import { Theme, TypographyProps, useTheme } from '@mui/material';
import { RepoTypes } from 'common-types';
import React, { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ReactComponent as FakeAppLogoDark } from '../../assets/icons/fake-app-icon-dark.svg';
import { ReactComponent as FakeAppLogoLight } from '../../assets/icons/fake-app-icon-light.svg';
import { splitLongNames } from 'string-utils';
import { generateIcons } from '../../issues/common/utils/issue-utils';
import MultiLineEllipsis from '../MultiLineEllipsis/MultiLineEllipsis';

const ApplicationCell: FC<React.PropsWithChildren<ApplicationCellProps>> = ({
  appName,
  appType,
  onClick,
  ...textProps
}) => {
  const { classes } = useStyles();
  const { RepoIcon } = generateIcons(undefined, appType);
  const theme = useTheme();
  return (
    <div className={classes.applicationCell}>
      <div className={classes.iconContainer}>
        {RepoIcon ? (
          <RepoIcon className={classes.repoIcon} />
        ) : theme.palette.mode === 'dark' ? (
          <FakeAppLogoLight className={classes.repoIcon} />
        ) : (
          <FakeAppLogoDark className={classes.repoIcon} />
        )}
      </div>
      <MultiLineEllipsis
        lines={2}
        variant='body2'
        onClick={onClick}
        {...textProps}>
        {splitLongNames(appName, 30)}
      </MultiLineEllipsis>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  applicationCell: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  iconContainer: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.primary,
  },
  repoIcon: {
    width: '1rem',
    height: '1rem',
    color: theme.palette.text.primary,
    flexShrink: 0,
  },
}));

interface ApplicationCellProps extends TypographyProps {
  appName: string;
  appType: RepoTypes;
  onClick?: (event: React.SyntheticEvent) => void;
}

export default ApplicationCell;
